import { render } from "./comentariosCarier.vue?vue&type=template&id=8a43eb12"
import script from "./comentariosCarier.vue?vue&type=script&lang=js"
export * from "./comentariosCarier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__